import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import P from '@leverege/promise';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { Button } from '@leverege/ui-elements';
import { Blocker } from '@leverege/molten/views';
import { jsx as _jsx } from "react/jsx-runtime";
class LocatorEquipmentLink extends React.Component {
  constructor(props) {
    super(props);
    const {
      value,
      object
    } = props;
    this.initialLoad = P.deferred();
    if (value && value !== '-') {
      let ref = object.ref;
      if (ref.indexOf('locators') > -1) {
        ref = ref.replace('locators', 'assetsLocators');
        ref = ref.endsWith('assetsLocators') ? ref : trimRef(ref);
      } else if (ref.indexOf('locator') > -1) {
        ref = ref.replace('locator', 'assetLocators');
        ref = ref.endsWith('assetLocators') ? ref : trimRef(ref);
      }
      const equipmentObj = {
        id: value,
        ref,
        type: 'assetLocators'
      };
      this.equipmentActions = DataSources.getActions(equipmentObj);
      console.log({
        equipmentActions: this.equipmentActions,
        equipmentObj
      }, 'Equipment Actions');
    }
  }
  componentDidMount() {
    const {
      value,
      asset
    } = this.props;
    if (!asset && value && this.equipmentActions) {
      GlobalState.dispatch(this.equipmentActions.get()).then(() => {
        this.initialLoad.resolve();
      });
    } else {
      this.initialLoad.resolve();
    }
  }
  onClick = () => {
    if (this.equipmentActions) {
      GlobalState.dispatch(this.equipmentActions.parent().goTo(this.equipmentActions.id));
    }
  };
  renderChildren = () => {
    const {
      asset
    } = this.props;
    if (asset) {
      return /*#__PURE__*/_jsx(Button, {
        variant: "detailSecondary",
        onClick: this.onClick,
        children: "Go To Equipment"
      });
    }
    return null;
  };
  render() {
    const matchContext = {
      client: 'LocatorEquipmentLink'
    };
    return /*#__PURE__*/_jsx(Blocker, {
      matchContext: matchContext,
      context: this.props,
      hooks: [{
        execute: () => this.initialLoad
      }],
      render: this.renderChildren,
      small: true,
      loadingProps: {
        inline: true
      }
    });
  }
}
export default connect((state, props) => {
  const {
    value
  } = props;
  const {
    models: {
      lookup
    }
  } = state;
  const asset = lookup[value];
  return {
    asset
  };
})(LocatorEquipmentLink);
function trimRef(ref) {
  const arr = ref.split('/');
  arr.pop();
  return arr.join('/');
}